import { useEffect, useRef } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { api } from "@/lib/api";
import Header from "@/components/shop/Header";
import Footer from "@/components/shop/Footer";
import CartSheet from "@/components/shop/CartSheet";
import { CompareBar } from "@/components/shop/Compare";
import { CookieBanner } from "@/components/shop/CookieBanner";

export default function ShopLayout() {
  const { pathname } = useLocation();
  const lastTracked = useRef(null);

  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);

  useEffect(() => {
    if (lastTracked.current === pathname) return;
    lastTracked.current = pathname;
    api.post("/track/visit", { path: pathname, referrer: document.referrer }).catch(() => {});
  }, [pathname]);

  return (
    <div className="min-h-screen flex flex-col bg-[#1F2230]">
      <Header />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
      <CartSheet />
      <CompareBar />
      <CookieBanner />
    </div>
  );
}
